import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      gridArea: 'filters',
      display: ['none', 'contents'],
    };

    this.sticky = {
      top: ['var(--header-height)'],
      position: 'sticky',
      bg: 'white',
      zIndex: 2,
      gridArea: 'filters',
    };

    this.heading = (hasLongWord) => ({
      variant: 'text.h2',
      mb: '28px',
      overflowWrap: 'break-word',
      ...(hasLongWord ? { fontSize: '28px' } : {}),
      gridArea: 'title',
    });

    this.accordionHeader = {
      heading: {
        variant: 'text.label.1',
        display: 'inline-block',
      },

      selected: {
        variant: 'text.base',
        textTransform: 'none',
        display: 'inline',
        color: 'mediumDarkGray',
        ml: 4,
      },
    };

    this.clearButton = {
      mt: 10,
    };
  })()
);
